
import {
    GET_SYSTEM_SETTINGS_SUCCESS,
    GET_SYSTEM_SETTINGS_FAIL,
    UPDATE_SYSTEM_SETTINGS_SUCCESS,
    UPDATE_SYSTEM_SETTINGS_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    settings: [],
    loading: false,
    error: {},
}

const settingsAdmin = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SYSTEM_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.payload,
            }

        case GET_SYSTEM_SETTINGS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_SYSTEM_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
            }

        case UPDATE_SYSTEM_SETTINGS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }

        default:
            return state
    }
}

export default settingsAdmin
